import styled from 'styled-components'

const Dot = ({ current = false, handleClick = null, name }) => {
  // console.log(name)
  // console.log(current)
  return (
    <Wrap> <InnerWrap $current={current}
      onClick={handleClick}></InnerWrap>
    </Wrap>
  )
}

export default Dot


const InnerWrap = styled.div`
  width: 14px;
  height: 14px;
  background: ${(props) => (props.$current ? '#222' : '#555')};
  border-radius: 50%;
  transition: .3s background-color;
  
  @media (prefers-color-scheme: dark) {
    background: ${(props) => (props.$current ? '#fff' : '#555')};
  }

  @media (width > 800px) {
    width: 16px;
    height: 16px;
    padding: 6px;
  }
  
  &:hover {
 
    background: ${(props) => (props.$current ? '#222' : '#444')};

      @media (prefers-color-scheme: dark) {
    background: ${(props) => (props.$current ? '#fff' : '#aaa')};
  }
    }
  
  `
const Wrap = styled.div`
  cursor: pointer;
  padding: 6px;


  /* width: 10px;
  height: 10px; */
  /* background: ${(props) => (props.$active ? 'var(--dot-accent)' : 'color-mix(in srgb, var(--dot-accent), var(--fader))')}; */
  /* background: ${(props) => (props.$active ? '#222' : '#ccc')}; */
  
  /* &:hover {
    background: ${(props) => (props.$active ? '#222' : '#777')};
    
    @media (prefers-color-scheme: dark) {
      background: ${(props) => (props.$active ? '#fff' : '#aaa')};
    }
  } */
  `